// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bf926224","703":"f2c88316"}[chunkId] + ".chunk.js";
};